export default __webpack_public_path__ + "static/media/pokemon_common.9db261e0.svg";